/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from '@module-logger/mbp';
import { func, bool } from 'prop-types';

import LoadGooglPayScript from '../LoadGooglePayScript/LoadGooglePayScript';

import {
    getIsGooglePaySupported,
} from '../../../../../../../../state/ducks/Payment/plugins/GooglePay/GooglePay-Helper';

class GooglePay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isGooglePaySupported: null,
            isGooglePayLoaded: null,
        };
        this.googlePayInitialized = false;
    }

    checkGooglePaySupported = async () => {
        this.googlePayInitialized = true;
        try {
            mbpLogger.logDebug({
                appName: process.env.npm_package_name,
                module: 'mbp-pwa-ui',
                function: 'checkGooglePaySupported',
                message: 'Check GooglePay supported',
            });
            const isGooglePaySupported = await getIsGooglePaySupported();
            const isGooglePayLoaded = true;
            this.setState({ isGooglePaySupported, isGooglePayLoaded });
        } catch (ex) {
            this.setState({ isGooglePaySupported: false, isGooglePayLoaded: false });

            mbpLogger.logError({
                appName: process.env.npm_package_name,
                module: 'mbp-pwa-ui',
                function: 'checkGooglePaySupported',
                jsError: ex,
                message: 'Failed to check Google Pay supported',
            });
        }
    }

    render() {
        const {
            render,
            featureEnabled,
        } = this.props;
        const { isGooglePaySupported, isGooglePayLoaded } = this.state;

        if (featureEnabled) {
            return (
                <LoadGooglPayScript render={({ isScriptLoaded, isScriptLoadSucceed }) => {
                    if (isScriptLoaded && isScriptLoadSucceed && !this.googlePayInitialized) {
                        this.checkGooglePaySupported();
                    }
                    return render({
                        isScriptLoaded,
                        isScriptLoadSucceed,
                        isGooglePaySupported,
                        isGooglePayLoaded,
                    });
                }}
                />
            );
        }

        return (render({
            isScriptLoaded: false,
            isScriptLoadSucceed: false,
            isGooglePaySupported: false,
            isGooglePayLoaded: false,
        }));
    }
}

GooglePay.propTypes = {
    featureEnabled: bool,
    render: func.isRequired,
};

GooglePay.defaultProps = {
    featureEnabled: false,
};

export default GooglePay;
